import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Button } from '@awesomecomponents/mux';
import { BREAKPOINTS } from '@awesomecomponents/mux/core/spacing';
import { BUTTON_VARIANT } from '@awesomecomponents/mux/core/components/Button';
import { errorModalContext } from '../utils/appConstants';

const ModalHeading = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 8px 0;
  text-align: center;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 14px 0 20px 0;
    text-align: center;
  }
`;

const ModalContent = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: center;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 0 0 30px 0;
    text-align: center;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 0 5px 0;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 0;
  }
`;

const ErrorModal = ({ isErrorModalOpen, lang, onRedirectAfterExit }) => {
  const context = lang === 'fr-CA' ? errorModalContext.errorFr : errorModalContext.errorEn;
  const modalRef = useRef(null);
  /**
   * Set focus on modal for accessiblity.
   */
  useEffect(() => {
    if (isErrorModalOpen) {
      modalRef.current.focus();
    }
  }, [isErrorModalOpen]);

  return (
    <div ref={modalRef}>
      <Modal
        id="errorModal"
        data-testid="errorModal"
        isOpen={isErrorModalOpen}
        onClose={onRedirectAfterExit}
        shouldCloseOnBackdropClick={false}
      >
        <ModalHeading>{context.headerText}</ModalHeading>
        <ModalContent>{context.bodyText}</ModalContent>
        <ButtonWrapper>
          <Button
            id="formhero-exitmodal-cancel"
            onClick={() => onRedirectAfterExit(false)}
            variant={BUTTON_VARIANT.PRIMARY}
          >
            {context.error_modal_button_okay}
          </Button>
        </ButtonWrapper>
      </Modal>
    </div>
  );
};

export default ErrorModal;
